import { apiSend } from './client';

export interface ClientErrorReport {
  kind?: string;
  message: string;
  stack?: string;
  route?: string;
  source?: string;
  version?: string;
}

/**
 * Hands a failure to the API, which logs it as a structured error and so puts it in Datadog beside the
 * server-side ones. Never rejects: this is called from the last-resort handlers, and a reporter that throws
 * while reporting turns a visible bug into an invisible one - or, from unhandledrejection, into a loop.
 */
export async function reportClientError(report: ClientErrorReport): Promise<void> {
  try {
    await apiSend('/api/client-errors', 'POST', report);
  } catch {
    // Signed out, offline, rate-limited, or the API itself is down: all of them mean this report is lost,
    // and none of them is worth a second failure on top of the first.
  }
}
